import styled from 'styled-components';

import { spaceXS } from '@xing-com/tokens';

export const Container = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;

export const OverflowLabel = styled.span`
  margin-left: ${spaceXS};
  visibility: hidden;
  opacity: 0;

  &.visible {
    visibility: visible;
    opacity: 1;
  }
`;
